import { Component, OnInit } from '@angular/core';
import { OnDestroyHookDirective } from '../common/hooks';
import { IAggregatorMonth } from 'src/app/my-bill/models/aggregator.model';
import { selectBillingAggregator } from 'src/app/state/selectors/billing-aggregator.selectors';
import { Store } from '@ngrx/store';
import { ApplicationState } from 'src/app/state/reducers';
import { filter, tap } from 'rxjs/operators';
import { InceptionService } from '@dch/ng-common';
import { getBillingAggregatorRequest } from 'src/app/state/actions/billing-aggregator.actions';
import { MessageBoxTypesEnum } from '@dch/pxs-angular-design-system/src/lib/messages/message-box';

@Component({
  selector: 'my-bill-evolution-chart-page',
  templateUrl: './my-bill-evolution-chart-page.component.html',
  standalone: false,
})
export class MyBillEvolutionChartPageComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  constructor(
    private store: Store<ApplicationState>,
    private inceptionService: InceptionService
  ) {
    super();
  }

  evolutionByMonth?: Array<IAggregatorMonth>;
  isFetching = true;
  hasError = false;
  messageBoxTypeError = MessageBoxTypesEnum.Error;
  displayedAggregatorMonth: IAggregatorMonth;

  ngOnInit() {
    this.store.dispatch(getBillingAggregatorRequest());
    this.setAggregatorData();
    this.scrollToTop();
  }

  private setAggregatorData() {
    this.addSubscription(
      this.store
        .select(selectBillingAggregator)
        .pipe(
          filter((selectBillAggregator) => selectBillAggregator !== undefined),
          tap((selectBillAggregator) => {
            this.isFetching = selectBillAggregator.isFetching;
            this.hasError = selectBillAggregator.hasError;
            this.evolutionByMonth =
              selectBillAggregator.billAggregatorResponse?.months;
          })
        )
        .subscribe()
    );
  }

  private scrollToTop(): void {
    // scroll to top #maincontent in my-bill-odb-details-page-base-structure component
    setTimeout(() => this.inceptionService.scrollToElement('#maincontent'));
  }

  onMonthItemClick(aggregatorMonth: IAggregatorMonth) {
    this.displayedAggregatorMonth = aggregatorMonth;
  }
}
